import { http } from "@/http/axios.js";
import { hideScreenLoading, showScreenLoading } from "@/http/loading";
import axios from "axios";
import { getToken } from "@/utils/auth";
import { dateFormat } from "@/utils";

// 模板分页查询
export function getTemplatePage(params) {
  return http({
    url: "/admin/store/goods/price/tpl/page",
    method: "get",
    params,
  });
}

// 编辑模板商品价格
export function editTemplateGoodsAPI(data) {
  return http({
    url: "/admin/store/goods/price/tpl/goods/edit",
    method: "post",
    data,
  });
}

// 模板内商品上下架
export function editTemplateGoodsStatusAPI(data) {
  return http({
    url: "/admin/store/goods/price/tpl/goods/status/edit",
    method: "post",
    data,
  });
}

// 修改模板内商品回收价
export function editTemplateRecyclePriceAPI(data) {
  return http({
    url: "/admin/store/goods/price/tpl/goods/recyclePrice/edit",
    method: "post",
    data,
  });
}

// 模板详情列表
export function getTemplateGoodsPage(params) {
  return http({
    url: "/admin/store/goods/price/tpl/goods/page",
    method: "get",
    params,
  });
}

// 新增
export function addTemplate(data) {
  return http({
    url: "/admin/store/goods/price/tpl/add",
    method: "post",
    data,
  });
}

// 编辑（重命名）
export function editTemplate(data) {
  return http({
    url: "/admin/store/goods/price/tpl/edit",
    method: "post",
    data,
  });
}

// 导出
export function exportTemplate(data, fileName) {
  showScreenLoading();
  axios({
    method: "post",
    url: "/api/admin/store/goods/price/tpl/goods/export",
    responseType: "blob",
    data,
    headers: {
      Authorization: getToken() || "",
    },
  })
    .then(async (res) => {
      hideScreenLoading();
      let blobData = res.data;
      let url = window.URL.createObjectURL(new Blob([blobData]));
      let a = document.createElement("a");
      a.style.display = "none";
      a.href = url;
      let filename = fileName ? `${fileName}.xlsx` : `商品价格模板${dateFormat()}.xlsx`;
      a.setAttribute("download", decodeURIComponent(filename));
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(a.href);
      document.body.removeChild(a);
    })
    .catch((error) => {
      hideScreenLoading();
      console.log(error);
    });
}

// 模板数据导入
export function importTemplate(data) {
  return http({
    url: "/admin/store/goods/price/tpl/goods/import",
    method: "post",
    data,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}
